import React from 'react';
import { WebSocketAdapter } from '../../utils/WebSocketAdapter';
import type { RoomState } from '../../types/room';
import { normalizeGameType } from '../../utils/normalizeGameType';
import GameDisplay from './GameDisplay';
import SpeedChallengeHostDisplay from './SpeedChallengeHostDisplay';
import CloseOrNotHostDisplay from './CloseOrNotHostDisplay';
import DrinkingGameHostDisplay from './DrinkingGameHostDisplay';
import HotTakesHostDisplay from './HotTakesHostDisplay';
import AreYouDrunkHostDisplay from './AreYouDrunkHostDisplay';
import WouldYouRatherHostDisplay from './WouldYouRatherHostDisplay';
import KinkyOrNotHostDisplay from './KinkyOrNotHostDisplay';
import StonedYetHostDisplay from './StonedYetHostDisplay';
import WhatCouldItBeHostDisplay from './WhatCouldItBeHostDisplay';
import BreakTheCodeHostDisplay from './BreakTheCodeHostDisplay';
import AssociationsHostDisplay from './AssociationsHostDisplay';
import CatchShoutCatchHostDisplay from './CatchShoutCatchHostDisplay';
import HouseRunHostDisplay from './HouseRunHostDisplay';
import OneBrainHostDisplay from './OneBrainHostDisplay';

export interface HostDisplayProps {
  roomState: RoomState;
  socket: WebSocketAdapter;
  onBackToGameSelection?: () => void;
  myPlayerId?: string;
  hostIsPlaying?: boolean;
  onGoHome?: () => void;
  onLoadingTimeout?: () => void;
}

type HostDisplayComponent = React.ComponentType<HostDisplayProps>;

/**
 * Registry: normalized game type → host screen.
 * Mirrors PlayerDisplay; App should route all non-bonus host play through this.
 */
const HOST_DISPLAY_REGISTRY: Record<string, HostDisplayComponent> = {
  'speed-challenge': SpeedChallengeHostDisplay,
  'close-or-not': CloseOrNotHostDisplay,
  'how-many': CloseOrNotHostDisplay,
  'estimate-it': CloseOrNotHostDisplay,
  'drinking-game': DrinkingGameHostDisplay,
  'hot-takes': HotTakesHostDisplay,
  'are-you-drunk': AreYouDrunkHostDisplay,
  'vision-check': AreYouDrunkHostDisplay,
  'would-you-rather': WouldYouRatherHostDisplay,
  'kinky-or-not': KinkyOrNotHostDisplay,
  'stoned-yet': StonedYetHostDisplay,
  'what-could-it-be': WhatCouldItBeHostDisplay,
  'clue-in': WhatCouldItBeHostDisplay,
  'what-am-i': WhatCouldItBeHostDisplay,
  'guess-what': WhatCouldItBeHostDisplay,
  'break-the-code': BreakTheCodeHostDisplay,
  'associations': AssociationsHostDisplay,
  'catch-shout-catch': CatchShoutCatchHostDisplay,
  'house-run': HouseRunHostDisplay,
  'one-brain': OneBrainHostDisplay,
  default: GameDisplay,
};

function getHostDisplayComponent(gameType: string): HostDisplayComponent {
  const normalizedType = normalizeGameType(gameType);
  return HOST_DISPLAY_REGISTRY[normalizedType] || HOST_DISPLAY_REGISTRY.default;
}

const HostDisplay: React.FC<HostDisplayProps> = (props) => {
  const Component = getHostDisplayComponent(props.roomState.gameType);
  return <Component {...props} />;
};

export default HostDisplay;
